import usePagebuilder from '../../../../hooks/pagebuilder/usePagebuilder';
import { SpeakerEntry } from '../../../../interfaces/pagebuilder';
import { fetchAndSetEventSpeakers, setPBAddSpeakerComponent } from '../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../reduxToolkit/typedRedux';
import { createSpeaker } from '../../../../services/services';
import SpeakerForm from '../Settings/speakers/SpeakerSettings/SpeakerForm';

const AddSpeakerModal = () => {
  const event = useSelector((state) => state.common.event);
  const PBAddSpeakerComponent = useSelector((state) => state.common.PBAddSpeakerComponent);

  const { editComponent } = usePagebuilder();
  const dispatch = useDispatch();

  async function handleCreateSpeaker(props: SpeakerEntry) {
    if (!event) return;
    if (!PBAddSpeakerComponent) return;
    try {
      delete props._id;
      const speaker = await createSpeaker(event?._id, props);
      const newComponent = { ...PBAddSpeakerComponent };
      newComponent.entryIds = [...newComponent.entryIds, speaker];
      editComponent(newComponent);
      dispatch(fetchAndSetEventSpeakers(event._id));
    } catch (error) {
      console.error(error);
    }
    closeModal();
  }

  const closeModal = () => {
    dispatch(setPBAddSpeakerComponent(undefined));
  };

  return <SpeakerForm onSpeakerCreated={handleCreateSpeaker} isModal isModalOpen={true} onCloseModal={() => closeModal()} />;
};
export default AddSpeakerModal;
